import React, { useEffect, useState } from 'react';

import Switch from '@material-ui/core/Switch';

const SwitchCell = ({ value: initialValue, row: { index }, column: { id }, rowToEdit, updateMyData }) => {
  const [value, setValue] = useState(initialValue);

  const onChange = (e) => {
    setValue(e.target.checked);
    updateMyData({ accessor: id, value: e.target.checked });
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <div>
      <Switch
        disabled={!(rowToEdit.index === index && rowToEdit.status)}
        checked={value}
        onChange={onChange}
        name="checkedA"
        inputProps={{ 'aria-label': 'secondary checkbox' }}
      />
    </div>
  );
};

export default SwitchCell;
